export enum Role {
  admin = 'admin',
  kiLeader = 'ki_leader',
  maintenanceCOE = 'cm_coe',
  backtagAdmin = 'backtag_admin',
  developer = 'developer',
  planningAccess = 'planning_access',
  planningReadonly = 'planning_readonly',
  owner = 'owner',
  planner = 'planner',
  dataManager = 'dataManager',
  efsManager = 'efsManager',
  conferencePlanner = 'conferencePlanner',
  questionManager = 'questionManager',
  backtagger = 'backtagger'
}
